import React from "react";
import { useAudioPlayerContext } from "contexts/audio-context";

const WaveformPlayer = ({ isPlaying, waveformRef, waveSurferInstance }) => {

  const {
    duration,
    audioRef,
    setDuration,
    progressBarRef,
    timeProgress,
    setTimeProgress,
  } = useAudioPlayerContext();

  const handleProgressChange = () => {
    if (audioRef.current && progressBarRef.current) {
      const newTime = Number(progressBarRef.current.value);
      audioRef.current.currentTime = newTime;
      setTimeProgress(newTime);

      waveSurferInstance.current?.seekTo(newTime / duration);
      progressBarRef.current.style.setProperty(
        "--range-progress",
        `${(newTime / duration) * 100}%`
      );
    }
  };

  return (
    <div className="waveform-player">
      <div ref={waveformRef} className="waveform"></div>
      <input
        ref={progressBarRef}
        type="range"
        min="0"
        max={duration || 0}
        step="0.1"
        value={timeProgress}
        onChange={handleProgressChange}
      />
    </div>
  );
};

export default WaveformPlayer;
